<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<div class="utitle">
				农药玩家你好,
				<br />
				欢迎进入虚贝账号评估系统
			</div>
			<div class="form-input">
				<div class="finput" @click="toShow(hero_num, 1)">
					<span class="num">英雄数量</span>
					<span class="val">
						<em>{{ hero_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
				<div class="finput" @click="toShow(skin_num, 2)">
					<span class="num">皮肤数量</span>
					<span class="val">
						<em>{{ skin_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(level_num, 3)">
					<span class="num">贵族等级</span>
					<span class="val">
						<em>{{ level_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(dw_num, 4)">
					<span class="num">段位</span>
					<span class="val">
						<em>{{ dw_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(cs_num, 5)">
					<span class="num">传说皮肤</span>
					<span class="val">
						<em>{{ cs_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(epic_num, 6)">
					<span class="num">史诗皮肤</span>
					<span class="val">
						<em>{{ epic_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(limit_num, 7)">
					<span class="num">限定皮肤</span>
					<span class="val">
						<em>{{ limit_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(honour_num, 8)">
					<span class="num">荣耀水晶</span>
					<span class="val">
						<em>{{ honour_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
			</div>
		</div>

		<div class="ftBtn">
			<router-link to="/" class="fh"><img src="/static/images/returnBtn.png" /></router-link>
			<div class="gz" @click="guzhi"><img src="/static/images/gzBtn.png" /></div>
		</div>

		<!-- <vue-pickers :show="show" :columns="columns" :defaultData="defaultData" :selectData="pickData" @cancel="close" @confirm="confirmFn"></vue-pickers> -->
		<vue-pickers
			:show="show"
			:columns="columns"
			:defaultData="defaultData"
			:isRemember="true"
			:selectData="pickerData"
			@cancel="close"
			@confirm="confirmFn"
		></vue-pickers>
		<div class="mask" v-if="isMask"></div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { Toast } from 'mint-ui';
export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			isMask: false,
			show: false,
			type: 1,
			columns: 1,
			pickerData: {},
			defaultData: [],
			hero_defaultData: [{ text: '0-20', value: '720' }],
			hero_num: {
				data1: [
					{ text: '0-20', value: '720' },
					{ text: '21-40', value: '1680' },
					{ text: '41-60', value: '2640' },
					{ text: '61-82', value: '3648' }
				]
			},

			skin_defaultData: [{ text: '0-40', value: '1020' }],
			skin_num: {
				data1: [
					{ text: '0-40', value: '1020' },
					{ text: '41-80', value: '4624' },
					{ text: '81-120', value: '7820' },
					{ text: '121-160', value: '9860' },
					{ text: '161-198', value: '12580' }
				]
			},

			level_defaultData: [{ text: 'V4及以下', value: '200' }],
			level_num: {
				data1: [
					{ text: 'V4及以下', value: '200' },
					{ text: 'V5', value: '500' },
					{ text: 'V6', value: '900' },
					{ text: 'V7', value: '1500' },
					{ text: 'V8', value: '2000' }
				]
			},

			dw_defaultData: [{ text: '青铜', value: '5' }],
			dw_num: {
				data1: [
					{ text: '青铜', value: '5' },
					{ text: '白银', value: '10' },
					{ text: '黄金', value: '50' },
					{ text: '铂金', value: '100' },
					{ text: '钻石', value: '200' },
					{ text: '星耀', value: '500' },
					{ text: '最强王者', value: '1000' },
					{ text: '荣耀王者', value: '2000' }
				]
			},
			cs_defaultData: [{ text: '0~1', value: '120' }],
			cs_num: {
				data1: [
					{ text: '0~1', value: '120' },
					{ text: '2~3', value: '375' },
					{ text: '4~5', value: '675' },
					{ text: '6~7', value: '975' },
					{ text: '8级以上', value: '1200' }
				]
			},

			epic_defaultData: [{ text: '0~5', value: '300' }],
			epic_num: {
				data1: [
					{ text: '0~5', value: '300' },
					{ text: '6~10', value: '600' },
					{ text: '11~15', value: '1800' },
					{ text: '16~20', value: '2300' },
					{ text: '21以上', value: '3150' }
				]
			},
			limit_defaultData: [{ text: '0~8', value: '1500' }],
			limit_num: {
				data1: [
					{ text: '0~8', value: '1500' },
					{ text: '9~16', value: '2600' },
					{ text: '17~24', value: '4800' },
					{ text: '25~32', value: '6500' },
					{ text: '33以上', value: '8000' }
				]
			},
			honour_defaultData: [{ text: '0', value: '0' }],
			honour_num: {
				data1: [
					{ text: '0', value: '0' },
					{ text: '1', value: '1500' },
					{ text: '2', value: '3000' },
					{ text: '3', value: '4500' },
					{ text: '4', value: '6000' },
					{ text: '5及以上', value: '7500' }
				]
			}
		};
	},
	mounted() {
		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {
		toShow(data, type) {
			console.log(data);
			this.show = true;
			this.isMask = true;
			this.pickerData = data;
			this.type = type;

			if (type === 1) {
				this.defaultData = this.hero_defaultData;
			} else if (type === 2) {
				this.defaultData = this.skin_defaultData;
			} else if (type === 3) {
				this.defaultData = this.level_defaultData;
			} else if (type === 4) {
				this.defaultData = this.dw_defaultData;
			} else if (type === 5) {
				this.defaultData = this.cs_defaultData;
			} else if (type == 6) {
				this.defaultData = this.epic_defaultData;
			} else if (type == 7) {
				this.defaultData = this.limit_defaultData;
			} else if (type == 8) {
				this.defaultData = this.honour_defaultData;
			}
		},
		close() {
			this.show = false;
			this.isMask = false;
		},
		confirmFn(val) {
			this.show = false;
			this.isMask = false;
			let type = this.type;
			if (type === 1) {
				this.hero_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 2) {
				this.skin_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 3) {
				this.level_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 4) {
				this.dw_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 5) {
				this.cs_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 6) {
				this.epic_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 7) {
				this.limit_defaultData = [val.select1];
				this.defaultData = [];
			} else if (type === 8) {
				this.honour_defaultData = [val.select1];
				this.defaultData = [];
			}
		},
		guzhi() {
			var guzhi =
				Number(this.hero_defaultData[0].value) +
				Number(this.skin_defaultData[0].value) +
				Number(this.level_defaultData[0].value) +
				Number(this.dw_defaultData[0].value) +
				Number(this.cs_defaultData[0].value) +
				Number(this.epic_defaultData[0].value) +
				Number(this.limit_defaultData[0].value) +
				Number(this.honour_defaultData[0].value);
			this.$router.push({ path: '/animation?id=1&username=' + this.username + '&amountValue=' + guzhi });
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	height: 100%;
	background: #241918 url(/static/images/wzry.jpg) no-repeat;
	background-size: 100% auto;
	.wzry_form {
		margin-bottom: px2rem(270rem);
		.utitle {
			color: #ffdd3f;
			font-size: px2rem(40rem);
			padding: 0 px2rem(70rem);
			margin-bottom: px2rem(64rem);
			padding-top: px2rem(260rem);
			letter-spacing: 1px;
			font-weight: bold;
			text-shadow: 1px 1px 1px #866e02;
		}

		.form-input {
			text-align: center;
			.finput {
				width: px2rem(610rem);
				height: px2rem(90rem);
				line-height: px2rem(90rem);
				background: #34271f;
				color: #ffddb5;
				border-radius: 5px;
				padding: 0 px2rem(15rem);
				margin: 0 auto;
				font-size: px2rem(30rem);
				position: relative;
				text-align: left;
				overflow: hidden;
				margin-bottom: px2rem(30rem);
				.num {
					color: #ffddb5;
					float: left;
				}
				.val {
					color: #fff;
					float: right;
					em {
						font-style: normal;
						padding-right: px2rem(20rem);
						opacity: 0.7;
					}
					img {
						width: px2rem(39rem);
						height: px2rem(23rem);
					}
				}
			}
		}
	}
	.ftBtn {
		display: flex;
		margin-top: px2rem(150rem);
		background: #000;
		padding: px2rem(20rem) 0;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		.fh {
			flex: 1;
			margin-left: px2rem(10rem);
			img {
				width: px2rem(252rem);
				height: px2rem(106rem);
			}
		}
		.gz {
			margin-right: px2rem(20rem);
			img {
				width: px2rem(436rem);
				height: px2rem(105rem);
			}
		}
	}

	.submitBtn {
		text-align: center;
		padding-top: px2rem(20rem);
		img {
			width: px2rem(616rem);
			height: px2rem(105rem);
		}
	}
	.copyRight {
		text-align: center;
		margin-top: px2rem(140rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}

.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}

.wzry_content /deep/ .area_grid {
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	-webkit-border-image: url(/static/images/dotted.jpg) 30 30 round;
	-o-border-image: url(/static/images/dotted.jpg) 30 30 round;
	border-image: url(/static/images/dotted.jpg) 30 30 round;
}

.wzry_content /deep/ .area_ctrl {
	font-size: 12px;
	vertical-align: middle;
	background-color: #413c3c;
	color: #fff;
	margin: 0;
	height: auto;
	width: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	bottom: 0;
	z-index: 9901;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	background-color: #393333;
	position: relative;
}

.wzry_content /deep/ .tooth {
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	line-clamp: 1;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn {
	color: #999;
	font-size: 1.6em;
	line-height: 1em;
	text-align: center;
	padding: 0.8em 1em;
}

.wzry_content /deep/ .larea_finish {
	color: #ffddb5;
}

.wzry_content /deep/ .area_btn_box:before,
.wzry_content /deep/ .area_btn_box:after {
	content: '';
	position: absolute;
	height: 1px;
	width: 100%;
	display: block;
	background-color: transparent;
	z-index: 15;
	-webkit-transform: scaleY(0.33);
	transform: scaleY(0.33);
}

.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	background: #000;
	opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/wzry.vue